import { useEffect, useState } from 'react'
import { getReferralsPoints as getReferralsPointsApi } from 'web-api-client'

const useReferralsPoints = (
  telegramId?: string
): { referralsPoints: number; isFetching: boolean } => {
  const [referralsPoints, setReferralsPoints] = useState<number>(0)
  const [isFetching, setIsFetching] = useState<boolean>(false)

  const getReferralsPoints = async (telegramId: string) => {
    setIsFetching(true)
    try {
      const { sum_points } = await getReferralsPointsApi(telegramId)

      setReferralsPoints(sum_points ?? 0)
    } catch (error) {
      console.log('error', error)
    } finally {
      setIsFetching(false)
    }
  }

  useEffect(() => {
    if (!telegramId) return

    getReferralsPoints(telegramId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [telegramId])

  return { referralsPoints, isFetching }
}

export default useReferralsPoints
